import { GlobalService } from 'src/app/_services/global.service';
import { environment } from 'src/environments/environment';
import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { map } from 'rxjs';
import { Manufacturer } from '../_models/manufacturer';

@Injectable({
  providedIn: 'root'
})
export class ManufacturersService {
  _globals = GlobalService
  showNewEdit = false
  showNewNewEdit = false
  isViewOnly=false
  activeItem: Manufacturer;

  constructor(private _bs: BaseService) { }

  getAllManufacturers(paras:any, auth: boolean = false, showSpinner: boolean = true) {
    const url = environment.InventoryBaseURL + environment.GetManufacturer

    return this._bs.httpGetParams(url, paras).pipe(map(res => {
      return res
    }))
  }

  createUpdateManufacturer(obj: any) {
    // 
    let url = environment.InventoryBaseURL+ environment.GetManufacturer
    url += obj.id ? ('/' + obj.id) : ''

    const model = {
      "id": obj.id,
      "manufacturerName": obj.manufacturerName,
      "isActive": obj.isActive,
    }
    if (obj.id) {
      return this._bs.httpPut(
        url,
        JSON.stringify(model), true).pipe(map(res => {
          if (res.success) {
            return res
          }
        }))
    } else {
      return this._bs.httpPost(
        url,
        JSON.stringify(model), true).pipe(map(res => {
          if (res.success) {
            return res
          }
        }))
    }
  }

  deleteManufacturer(id:string){
    let url = environment.InventoryBaseURL+ environment.GetManufacturer+"/"+id;

    return this._bs.httpDelete(url).pipe(map(response=>{
      return response;
    }))
  }

}
